module.exports = __webpack_public_path__ + "img/nail_bar.bd4fa1bf.png";